import React from 'react';
import PropTypes from 'prop-types';

export const Limited = ({ width, height, ...props }) => (
  <svg
    data-icon='limited'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M9 8h6V6c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 12 3c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 9 6v2Zm3.25 14H6c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 4 20V10c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 6 8h1V6c0-1.383.487-2.563 1.463-3.538C9.438 1.487 10.617 1 12 1s2.563.488 3.537 1.462C16.512 3.438 17 4.617 17 6v2h1c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v1.3a5.7 5.7 0 0 0-.938-.225A7.006 7.006 0 0 0 18 11v-1H6v10h5.3c.133.4.267.746.4 1.038.133.291.317.612.55.962ZM18 23c-1.383 0-2.563-.488-3.537-1.462C13.488 20.562 13 19.383 13 18s.488-2.563 1.463-3.537C15.438 13.488 16.617 13 18 13s2.563.488 3.538 1.463C22.512 15.438 23 16.617 23 18s-.488 2.563-1.462 3.538C20.562 22.512 19.383 23 18 23Zm1.65-2.65.7-.7-1.85-1.85V15h-1v3.2l2.15 2.15Z'
    />
  </svg>
);

Limited.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Limited.defaultProps = {
  width: 24,
  height: 24,
};
